import { BaseSymbolTypes } from "../services/symbolService";

export const laglessSpin = {
	symbols: new Map([
		[
			0,
			[
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.Scatter,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
			],
		],
		[
			1,
			[
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Scatter,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
			],
		],
		[
			2,
			[
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Scatter,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
			],
		],
		[
			3,
			[
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Scatter,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
			],
		],
		[
			4,
			[
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Scatter,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.Scatter,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.Mystery,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.Top,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.HV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV4,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.LV3,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.HV4,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.HV3,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.LV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.HV2,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
				BaseSymbolTypes.LV1,
			],
		],
	]),
	criticalSymbols: new Set([BaseSymbolTypes.Top, BaseSymbolTypes.Mystery, BaseSymbolTypes.Scatter, BaseSymbolTypes.ScatterFG]),
};
